export type SssDisplayMetadata = {
  n?: unknown;
  k?: unknown;
  holderLabels?: unknown;
};

export function isPositiveFiniteInteger(value: unknown): value is number {
  return typeof value === 'number'
    && Number.isFinite(value)
    && Number.isInteger(value)
    && value > 0;
}

/** True when Shamir holder counts and labels are present and consistent enough to display. */
export function hasConfiguredSssMetadata(
  sss: SssDisplayMetadata | null | undefined
): sss is { n: number; k: number; holderLabels: string[] } {
  if (!sss) return false;
  if (!isPositiveFiniteInteger(sss.n) || !isPositiveFiniteInteger(sss.k)) return false;
  if (!Array.isArray(sss.holderLabels) || sss.holderLabels.length < 2) return false;
  if (sss.n !== sss.holderLabels.length) return false;
  return true;
}

export function formatSssStatusSuffix(
  sss: SssDisplayMetadata | null | undefined
): string {
  if (!hasConfiguredSssMetadata(sss)) return '';
  return ` (${sss.n} holders, any ${sss.k} reconstruct)`;
}
